import { ReactElement, useEffect, useState } from "react";
import "./SecondRow.css";
import { appRoles } from "../../authConfig";
import { StoreWANWidget, TableInfo } from "../../Common/UI/components/StoreWANWidget";
import { FlexRow } from "../../Common/UI/components/FlexRow";
import useIsAuthorized from "../../Common/UI/hook/useIsAuthorized";
import { CardFreeInfo, WANStatuses, POSStatus, UberEats, AutomatedTestResult, DoorDash, DoorDashFeatureFlag } from "./Interfaces";
import useUserRoles from "../../Common/UI/hook/useUserRoles";

function WANStatusesConvert(WANStatuses: WANStatuses[]): TableInfo[] {
  var temp: TableInfo[] = [];

  WANStatuses.forEach((info) => {
    temp.push({
      location: info.locationWanInfo.location,
      col2: info.wan1Status,
      col2Name: "WAN 1",
      col1: info.wan2Status,
      col1Name: "WAN 2",
      status: info.status,
      key: "wan-info",
      updateDate: info.lastUpdated,
    });
  });
  return temp;
}

function CardFreeStatusesConvert(cardFreeInfo: CardFreeInfo[]): TableInfo[] {
  var temp: TableInfo[] = [];

  cardFreeInfo.forEach((info) => {
    temp.push({
      location: info.location, //location number
      col1Name: "Status", //most right col name
      col1: info.status, // most right col status
      status: info.status,
      key: "card-free-info",
      updateDate: info.lastUpdated,
      isOutsideWorkingHours: info.isOutsideWorkingHours
    });
  });
  return temp;
}

function POSStatusConvert(posStatuses: POSStatus[]): TableInfo[] {
  var temp: TableInfo[] = [];

  posStatuses.forEach((info) => {
    temp.push({
      location: info.location, //location number
      col1Name: "Status",
      col1: info.activeDevices > 0,
      status: info.activeDevices > 0,
      key: "pos-statuses",
      updateDate: info.lastUpdated,
    });
  });
  return temp;
}

function UberEatsStatusesConvert(uberEatsInfo: UberEats[]): TableInfo[] {
  var temp: TableInfo[] = [];

  uberEatsInfo.forEach((info) => {
    temp.push({
      location: info.location, //location number
      col1Name: "Status", //most right col name
      col1: info.status, // most right col status
      status: info.status,
      key: "uber-eats-info",
      updateDate: info.lastUpdated,
      isOutsideWorkingHours: info.isOutsideWorkingHours
    });
  });
  return temp;
}

function DoorDashStatusesConvert(doorDashInfo: DoorDash[]): TableInfo[] {
  var temp: TableInfo[] = [];

  doorDashInfo.forEach((info) => {
    temp.push({
      location: info.location, //location number
      col1Name: "Status", //most right col name
      col1: info.isActive, // most right col status
      status: info.isActive,
      key: "door-dash-info",
      updateDate: info.lastUpdated,
      isOutsideWorkingHours: info.isOutsideWorkingHours
    });
  });
  return temp;
}

export const SecondRow = function ({
  loadingWANStatuses,
  WANStatuses,
  loadingCardFreeStatuses,
  cardFreeStatuses,
  loadingUberEatsStatuses,
  uberEatsStatuses,
  loadingDoorDashFeatureFlag,
  doorDashFeatureFlag,
  loadingDoorDashStatuses,
  doorDashStatuses,
}: {
  loadingWANStatuses: boolean;
  WANStatuses: WANStatuses[];
  loadingCardFreeStatuses: boolean;
  cardFreeStatuses: CardFreeInfo[];
  loadingPOSStatuses: boolean;
  POSStatuses: POSStatus[];
  loadingUberEatsStatuses: boolean;
  uberEatsStatuses: UberEats[];
  loadingDoorDashFeatureFlag: boolean;
  doorDashFeatureFlag: DoorDashFeatureFlag;
  doorDashStatuses: DoorDash[];
  loadingDoorDashStatuses: boolean;
}): ReactElement {
  const { roles, isLoading } = useUserRoles();
  const showFirewallStatus = useIsAuthorized([appRoles.Home.FirewallStatus], roles);
  const showCardFree = useIsAuthorized([appRoles.Home.CardFreeStatus], roles);

  const showUberEats = useIsAuthorized([appRoles.Home.ViewUberEatsStatus], roles);

  const showDoorDash = useIsAuthorized([appRoles.Home.ViewDoorDashStatus], roles);

  const [wanInfo, setWanInfo] = useState<TableInfo[]>([]);
  const [CFInfo, setCFInfo] = useState<TableInfo[]>([]);
  const [uberEatsTable, setUberEatsTable] = useState<TableInfo[]>([]);
  const [doorDashTable, setDoorDashTable] = useState<TableInfo[]>([]);

  useEffect(() => {
    setWanInfo(WANStatusesConvert(WANStatuses));
  }, [WANStatuses]);

  useEffect(() => {
    setCFInfo(CardFreeStatusesConvert(cardFreeStatuses));
  }, [cardFreeStatuses]);

  useEffect(() => {
    setUberEatsTable(UberEatsStatusesConvert(uberEatsStatuses));
  }, [uberEatsStatuses]);

  useEffect(() => {
    setDoorDashTable(DoorDashStatusesConvert(doorDashStatuses));
  }, [doorDashStatuses]);

  return (
    <FlexRow>
      {showFirewallStatus && (
        <StoreWANWidget items={wanInfo} isLoading={loadingWANStatuses} title="Network Store Status" header="Store Number"></StoreWANWidget>
      )}
      {showCardFree && (
        <StoreWANWidget items={CFInfo} isLoading={loadingCardFreeStatuses} title="OLO Store Status" header="Store Name"></StoreWANWidget>
      )}

      {showUberEats && (
        <StoreWANWidget items={uberEatsTable} isLoading={loadingUberEatsStatuses} title="Uber Eats Store Status" header="Store Name"></StoreWANWidget>
      )}

      {showDoorDash && loadingDoorDashFeatureFlag == false && doorDashFeatureFlag.enabled && (
        <StoreWANWidget items={doorDashTable} isLoading={loadingDoorDashStatuses} title="Door Dash Store Status" header="Store Name"></StoreWANWidget>
      )}
    </FlexRow>
  );
};
